import { css } from '@emotion/react'
import { Theme, Color, Spacing, Typography } from '@opallabs/gem'

export const wrapper = (theme: Theme) =>
  css({
    color: Color[theme].Text.Default,
    padding: `${Spacing.M}px ${Spacing.S}px`,
    textAlign: 'start',
    inlineSize: 300,
  })

export const postOptionGroup = (theme: Theme) =>
  css({
    borderBlockEnd: `solid 1px ${Color[theme].Surface.N300}`,
    paddingBlockEnd: Spacing.M,
    '+ .kuiper-post-option-group': {
      paddingBlockStart: Spacing.S,
    },
    '&:last-child': {
      borderBlockEnd: 0,
    },
  })

export const optionGroupSection = (theme: Theme) =>
  css({
    borderBlockEnd: `solid 1px ${Color[theme].Surface.N300}`,
    paddingBlockEnd: Spacing.S,
    marginBlockEnd: Spacing.M,
  })

export const groupText = css({
  textTransform: 'uppercase',
  ...Typography.T300,
})

export const optionValue = (theme: Theme) =>
  css({
    color: Color[theme].Text.Gray,
    display: 'flex',
    columnGap: Spacing.XS,
    marginBlockStart: Spacing.XS,
    ...Typography.T300,
  })

export const optionTitle = css({
  fontSize: '11px',
  marginBlockStart: Spacing.XS,
  textTransform: 'uppercase',
})

export const labelSet = (theme: Theme) =>
  css({
    marginBlockStart: Spacing.S,

    '.kuiper-token': {
      backgroundColor: Color[theme].Surface.N500,
      marginBlockEnd: 0,
      marginBlockStart: Spacing.S,
      userSelect: 'auto',

      '.kuiper-tokenIcon': {
        paddingInlineStart: 0,

        '.kuiper-icon-wrapper': {
          backgroundColor: Color[theme].Surface.N400,
          blockSize: 20,
          inlineSize: 20,
        },
      },
    },

    '+ .kuiper-label-set-title': {
      marginBlockStart: 15,
    },
  })
